import { ScheduleTime } from './schedule-time.model';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

export class Schedule {
    public id: number;
    public name_it: string;
    public name_de: string;
    public name_en: string;
    public startDate: string;
    public endDate: string;
    public fullYear: boolean;
    public createdAt: string;
    public updatedAt: string;
    public status: number;
    public scheduleTime: ScheduleTime[];

    static convertDateToNgbDataStructure(date: string): NgbDateStruct {
        const dateArray = moment(date, 'YYYY-MM-DD', true).toArray();
        return {
            day: dateArray[2],
            month: dateArray[1] + 1,
            year: dateArray[0],
        };
    }

    static convertNgbDataStructureToDateString(date: NgbDateStruct): string {
        if (!date.year || !date.month || !date.day) {
            return undefined;
        }
        return date.year + '-' + (date.month < 10 ? '0' + date.month : date.month) + '-' + (date.day < 10 ? '0' + date.day : date.day);
    }
}
